import ApiClient from './ApiClient';

class BoletoClientsAPI extends ApiClient {
  constructor() {
    super('boleto_clients', { accountScoped: true });
  }

  // Get all boleto clients
  get() {
    return axios.get(this.url);
  }

  // Get a single boleto client
  show(clientId) {
    return axios.get(`${this.url}/${clientId}`);
  }

  // Create a new boleto client
  create(data) {
    return axios.post(this.url, data);
  }

  // Update a boleto client
  update(clientId, data) {
    return axios.patch(`${this.url}/${clientId}`, data);
  }

  // Delete a boleto client
  delete(clientId) {
    return axios.delete(`${this.url}/${clientId}`);
  }

  // Send boleto now (requires boleto_file_id)
  sendNow(clientId, boletoFileId) {
    return axios.post(`${this.url}/${clientId}/send_now`, {
      boleto_file_id: boletoFileId,
    });
  }

  // Get stats
  getStats() {
    return axios.get(`${this.url}/stats`);
  }

  // === Boleto Files ===

  // Get all files for a client
  getFiles(clientId, params = {}) {
    return axios.get(`${this.url}/${clientId}/boleto_files`, { params });
  }

  // Create a single file
  createFile(clientId, formData) {
    return axios.post(`${this.url}/${clientId}/boleto_files`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  // Bulk create files
  bulkCreateFiles(clientId, formData) {
    return axios.post(
      `${this.url}/${clientId}/boleto_files/bulk_create`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      }
    );
  }

  // Update a file
  updateFile(clientId, fileId, data) {
    return axios.patch(`${this.url}/${clientId}/boleto_files/${fileId}`, data);
  }

  // Delete a file
  deleteFile(clientId, fileId) {
    return axios.delete(`${this.url}/${clientId}/boleto_files/${fileId}`);
  }

  // Retry sending a failed file
  retryFile(clientId, fileId) {
    return axios.post(
      `${this.url}/${clientId}/boleto_files/${fileId}/retry_send`
    );
  }

  // Detect month from filename
  detectMonth(clientId, formData) {
    return axios.post(
      `${this.url}/${clientId}/boleto_files/detect_month`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      }
    );
  }
}

export default new BoletoClientsAPI();
